export default __webpack_public_path__ + "static/media/img-dao-mobile.59bb9aa3.png";